module.exports = __webpack_public_path__ + "img/210e8e6.jpg";